<ng-template #modal>
    <div class="quickview">
        <button class="quickview__close" type="button" appClick (click)="modalRef.hide()">
            <app-icon name="cross-20" size="20"></app-icon>
        </button>

        <app-product [product]="product" [isQuickView]="true" layout="quickview"></app-product>
    </div>
</ng-template>

<ng-template #addeditprodmodal>
    <div class="quickview">
        <button class="quickview__close" type="button" appClick (click)="modalRef.hide()">
            <app-icon name="cross-20" size="20"></app-icon>
        </button>  
    </div>
</ng-template> 

<ng-template #shopEnlistForm>
    <!-- The form draws its own head with the close button, and its own padding. -->
    <div class="shop-enlist-form">
        <app-shop-and-featuring-request-form [modalRef]="modalRef" [store]="store" [locations]="locations"></app-shop-and-featuring-request-form>  
    </div>
</ng-template> 

<ng-template #confirmAction>
    <div> 
        <app-confirm-action [modalRef]="modalRef" [msg]="msg" [uniqeId]="uniqeId"></app-confirm-action>  
    </div>
</ng-template> 

<ng-template #testmodal>
    <div class="popup-container">
      <app-icon class="close-btn"name="cross-20" size="28" style="fill: #f5f5f5;" appClick (click)="$event.preventDefault(); modalRef.hide()"></app-icon>
      <a href="/products/sale">
        <img src="assets/images/popups/discount-50-popup.webp" class="popup-image" />
      </a>
    </div>
</ng-template>
